export enum eJudgementLienDocumentType {
  judgement = 'judgement',
  lien = 'lien',
  ucc = 'ucc',
  other = 'other',
}

export enum JudgementLienDocumentTypeLabels {
  judgement = 'Judgement',
  lien = 'Lien',
  ucc = 'UCC',
  other = 'Other',
}
